import { ApiType } from "@gymflow/common";
import { FacilityCreateDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { facilityQueryKeys } from "./facilityQueryKeys";

export function useFacilityCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newFacility: FacilityCreateDTO) => {
      return (await api.facilityApi.create(newFacility)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facilityQueryKeys.all() });
    },
  });
}
